<div class="lg:flex items-start">
	<div
		class="p-24px bg-off-white rounded-12px lg:min-w-[320px] lg:mr-12px max-mobile:mb-margin-mobile-14 {{
			clientDetails?.emailAddress ? 'h-[435px]' : 'h-[340px]'
		}}  "
	>
		<!-- IMG NAME PHONE SECTION  -->
		<section class="text-center">
			<img
				[src]="attachementUrl + clientDetails?.profileImageUrl"
				alt=""
				class="rounded-[50%] inline-block w-[120px] h-[120px]"
				onerror="this.src='assets/images/logo.png'"
			/>
			<p
				class="text-font-18 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[6px] mt-12px"
			>
				{{ clientDetails?.name }}
			</p>
			<p class="text-dark-grey text-font-16">
				{{ clientDetails?.mobileNumber }}
			</p>
		</section>
		<!-- DATE & EMAIL -->
		<section>
			<div
				class="p-12px rounded-6px border-[1px] border-secondry-color-Gray text-center mb-12px"
			>
				<img
					alt=""
					class="inline-block mb-[8px]"
					src="./assets/images/calendar.svg"
				/>
				<p class="text-dark-grey text-font-16">
					{{ clientDetails?.registrationDate | date : 'dd/MM/yyyy' }}
				</p>
			</div>
			<div
				*ngIf="clientDetails?.emailAddress"
				class="p-12px rounded-6px border-[1px] border-secondry-color-Gray text-center font-Poppins-regular"
			>
				<img
					alt=""
					class="inline-block mb-[8px]"
					src="./assets/images/mail.svg"
				/>
				<p class="text-dark-grey text-font-14">
					{{ clientDetails?.emailAddress }}
				</p>
			</div>
		</section>
	</div>
	<!-- STATISTICS&TABLE -->
	<div class="p-24px rounded-12px grow">
		<!-- STATISTICS -->
		<div class="bg-off-white py-24px rounded-12px rtl:pr-24px ltr:pl-24px">
			<section class="flex overflow-x-scroll">
				<div class="flex mb-[2px] max-w-[700px]">
					<div
						class="flex justify-between min-w-[270px] px-24px py-[18px] ltr:mr-12px rtl:ml-12px border-[1px] border-secondry-color-Gray rounded-6px"
					>
						<div>
							<p
								class="text-dark-grey text-font-24 ltr:font-DIN-bold font-bold rtl:font-semibold mb-[10px]"
							>
								{{ clientDetails?.bookingCount }}
							</p>
							<p class="text-font-14 text-medium-gray mb-[10px]">
								{{ 'STATUS.ALL_BOOKING' | translate }}
							</p>
						</div>
						<div>
							<img alt="" src="./assets/images/statistic-1.svg" />
						</div>
					</div>
					<div
						class="flex justify-between min-w-[270px] px-24px py-[18px] ltr:mr-12px rtl:ml-12px border-[1px] border-secondry-color-Gray rounded-6px"
					>
						<div>
							<p
								class="text-dark-grey text-font-24 ltr:font-DIN-bold font-bold rtl:font-semibold mb-[10px]"
							>
								{{ clientDetails?.completedBookingCount }}
							</p>
							<p class="text-font-14 text-medium-gray mb-[10px]">
								{{ 'STATUS.COMPLETED' | translate }}
							</p>
						</div>
						<div>
							<img alt="" src="./assets/images/static--2.svg" />
						</div>
					</div>
					<div
						class="flex justify-between min-w-[270px] px-24px py-[18px] ltr:mr-12px rtl:ml-12px border-[1px] border-secondry-color-Gray rounded-6px"
					>
						<div>
							<p
								class="text-dark-grey text-font-24 ltr:font-DIN-bold font-bold rtl:font-semibold mb-[10px]"
							>
								{{ clientDetails?.cancelledBookingCount }}
							</p>
							<p class="text-font-14 text-medium-gray mb-[10px]">
								{{ 'STATUS.CANCELLED' | translate }}
							</p>
						</div>
						<div>
							<img alt="" src="./assets/images/statistic-3.svg" />
						</div>
					</div>
					<div
						class="flex justify-between min-w-[270px] px-24px py-[18px] ltr:mr-12px rtl:ml-12px border-[1px] border-secondry-color-Gray rounded-6px"
					>
						<div>
							<p
								class="text-dark-grey text-font-24 ltr:font-DIN-bold font-bold rtl:font-semibold mb-[10px]"
							>
								{{ clientDetails?.didnotShowUpBookingCount }}
							</p>
							<p class="text-font-14 text-medium-gray mb-[10px]">
								{{ 'STATUS.DIDNOTSHOWUP' | translate }}
							</p>
						</div>
						<div>
							<img alt="" src="./assets/images/statistic-2.svg" />
						</div>
					</div>
					<div
						class="flex justify-between min-w-[270px] px-24px py-[18px] ltr:mr-12px rtl:ml-12px border-[1px] border-secondry-color-Gray rounded-6px"
					>
						<div>
							<p
								class="text-dark-grey text-font-24 ltr:font-DIN-bold font-bold rtl:font-semibold mb-[10px]"
							>
								{{ clientDetails?.confirmedBookingCount }}
							</p>
							<p class="text-font-14 text-medium-gray mb-[10px]">
								{{ 'STATUS.CONFIRMED' | translate }}
							</p>
						</div>
						<div>
							<img alt="" src="./assets/images/statistic-2.svg" />
						</div>
					</div>
					<div
						class="flex justify-between min-w-[270px] px-24px py-[18px] ltr:mr-12px rtl:ml-12px border-[1px] border-secondry-color-Gray rounded-6px"
					>
						<div>
							<p
								class="text-dark-grey text-font-24 ltr:font-DIN-bold font-bold rtl:font-semibold mb-[10px]"
							>
								{{ clientDetails?.pendingBookingCount }}
							</p>
							<p class="text-font-14 text-medium-gray mb-[10px]">
								{{ 'STATUS.UNCONFIRMED' | translate }}
							</p>
						</div>
						<div>
							<img alt="" src="./assets/images/statistic-2.svg" />
						</div>
					</div>
				</div>
			</section>
		</div>
		<!-- COUNTRIES&FILTER&TABLE -->
		<section>
			<div
				class="max-w-[406px] mb-24px flex justify-evenly items-center py-[8px] max-mobile:p-0 px-[10px] bg-[#FCFCFC] rounded-[50px] text-dark-grey mt-[18px] text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
			>
				<a
					*ngFor="let country of activeCountries"
					[ngClass]="{
						activeClass: clientBookingFilter.countryId == country.id
					}"
					[queryParams]="{ country: country.id }"
					[routerLink]="'/layout/clients/client-profile/' + clientId"
					class="text-center w-[55%] max-mobile:text-font-mobile-small"
				>
					<!-- prettier-ignore -->
					<img [src]="attachementUrl + country.flagUrl" alt="" class="inline-block w-[24px]" />
					{{
						this.translate.currentLang === 'ar'
							? country?.name?.ar
							: country?.name?.en
					}}
				</a>
			</div>
		</section>
		<div class="p-24px bg-off-white rounded-12px">
			<!-- tabs -->
			<div class="my-12px overflow-x-auto">
				<app-tabs
					(tapChanged)="tapChanged($event)"
					[activeTap]="clientBookingFilter.activeTab"
					[taps]="ClientProfileStatus"
				>
				</app-tabs>
			</div>
			<!-- total balance -->

			<section
				*ngIf="clientBookingFilter.activeTab == 0"
				class="p-24px bg-img rounded-12px mb-12px max-w-[95%]"
			>
				<p class="text-off-white text-font-14 mb-6px">
					{{ 'WALLET.SP_WALLET.TOTALCOUNT' | translate }}
				</p>
				<h1 class="text-off-white text-font-24 font-DIN-bold mb-[3px]">
					<span>
						{{
							this.translate.currentLang === 'ar'
								? ClientWalletData?.currency?.name?.ar
								: ClientWalletData?.currency?.name?.en
						}}</span
					>
					{{ ClientWalletData?.walletAmount }}
				</h1>
				<div class="flex items-center">
					<div>
						<h1 class="text-off-white text-font-16 mb-0">
							{{ 'GENERAL_LABELS.CASHBACK' | translate }}
						</h1>
						<p class="text-off-white text-font-16 mb-2">
							{{ ClientWalletData?.cashBackAmount }}
							<span>{{
								translate.currentLang == 'en'
									? ClientWalletData?.currency?.name?.en
									: ClientWalletData?.currency?.name?.ar
							}}</span>
						</p>
					</div>
					<span class="bg-off-white w-[1px] h-[27px] mx-24px"></span>
					<div>
						<h1 class="text-off-white text-font-16 mb-0">
							{{ 'WALLET.SP_WALLET.PENDING_PAYOUT' | translate }}
						</h1>
						<p class="text-off-white text-font-16 mb-2">
							{{ ClientWalletData?.holdingPayouts }}
							<span>{{
								translate.currentLang == 'en'
									? ClientWalletData?.currency?.name?.en
									: ClientWalletData?.currency?.name?.ar
							}}</span>
						</p>
					</div>
				</div>

				<div class="flex">
					<button
						(click)="addSubtractFund('empty-wallet-add.svg', 'add')"
						class="bg-off-white py-[10px] px-24px text-dark-grey rounded-6px ltr:mr-6px rtl:ml-6px"
					>
						<span class="ltr:mr-8px rtl:ml-8px"
							><img
								alt=""
								class="inline-block"
								src="./assets/images/dark-grey-add.svg"
						/></span>
						{{ 'WALLET.SP_WALLET.ADD_FUND' | translate }}
					</button>
					<button
						(click)="
							addSubtractFund(
								'wallet-minus.svg',
								'sub',
								ClientWalletData?.walletAmount
							)
						"
						class="bg-transparent py-[10px] px-24px text-off-white rounded-6px border-[1px] border-off-white"
					>
						<span class="ltr:mr-8px rtl:ml-8px"
							><img
								alt=""
								class="inline-block"
								src="./assets/images/minus-white.svg"
						/></span>
						{{ 'WALLET.SP_WALLET.SUBTRACT_FUND' | translate }}
					</button>
				</div>
			</section>
			<section *ngIf="clientBookingFilter.activeTab == 0">
				<div class="flex justify-between items-center mb-16px">
					<h1 class="mb-0 mt-5">
						{{ 'WALLET.SP_WALLET.HISTORY' | translate }}
					</h1>
					<app-search-filter
						(resetFilter)="filter.resetFilter()"
						(toggleFilter)="sidenav.toggle()"
						[filterCount]="filterCount"
						[showSearch]="false"
					></app-search-filter>
				</div>
				<app-client-wallet-history
					*ngIf="walletData?.length"
					[totalCount]="totalWalletCount"
					[walletDataFilter]="clientBookingFilter"
					[walletDataTable]="walletData"
				></app-client-wallet-history>
				<app-no-data-found
					*ngIf="!walletData?.length"
					[text]="'CLIENT.CLIENT_LIST.NO_TRANSACTIONS'"
				></app-no-data-found>
				<div class="mt-8 py-5 max-mobile:overflow-auto">
					<app-pagination
						(currentPage)="
							pageChanged($event, clientBookingFilter.paging.pageSize)
						"
						(itemsCountPerPage)="pageChanged(1, $event)"
						[pageCount]="clientBookingFilter.paging.pageSize"
						[pageNumber]="clientBookingFilter.paging.pageNumber"
						[totalCount]="totalWalletCount"
					></app-pagination>
				</div>
				<ng-container>
					<mat-sidenav-container [hasBackdrop]="true" class="z-20">
						<mat-sidenav
							#sidenav
							[disableClose]="false"
							[disableClose]="false"
							[fixedBottomGap]="0"
							[fixedInViewport]="true"
							[fixedTopGap]="0"
							[opened]="false"
							class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
							mode="side"
							opened
							position="end"
						>
							<header class="tw-p-4 p-12px">
								<div class="rtl:text-left ltr:text-right">
									<button (click)="sidenav.toggle()">
										<img alt="" src="./assets/images/close-square.svg" />
									</button>
								</div>
							</header>
							<app-client-wallet-filter
								#filter
								(emitFilter)="
									getWalletTransactionList($event); sidenav.toggle()
								"
								(emitfilterCount)="filterCount = $event"
								[filterData]="clientBookingFilter"
							></app-client-wallet-filter>
						</mat-sidenav>
					</mat-sidenav-container>
				</ng-container>
			</section>

			<section
				*ngIf="clientBookingFilter.activeTab == 1"
				class="{{ !isFliped ? 'h-[750px] overflow-hidden' : ' h-[890px]' }}"
			>
				<div
					*ngIf="!isFliped"
					class="flex justify-between items-center mb-16px"
				>
					<div class="flex gap-2">
						<h1 class="mb-0 font-DIN-bold font-bold text-dark-grey">
							{{ 'PAYOUT.PAYOUTS' | translate }}
						</h1>
						<span
							*ngIf="pendingCount != 0"
							class="h-[25px] w-[25px] rounded-full bg-gradient text-center mt-1 pt-1 text-off-white text-[12px]"
							>{{ pendingCount }}</span
						>
					</div>
					<app-search-filter
						(resetFilter)="payoutFilter.resetFilter()"
						(toggleFilter)="sidenav.toggle()"
						[filterCount]="payoutfilterCount"
						[showSearch]="false"
					></app-search-filter>
				</div>
				<app-client-payouts
					(flipped)="isFliped = $event"
					[payoutDataFilter]="clientBookingFilter"
					[payoutDataTable]="payoutDataTable"
					[totalCount]="payoutCount"
				></app-client-payouts>
				<ng-container>
					<mat-sidenav-container [hasBackdrop]="true" class="z-20">
						<mat-sidenav
							#sidenav
							[disableClose]="false"
							[fixedBottomGap]="0"
							[fixedInViewport]="true"
							[fixedTopGap]="0"
							[opened]="false"
							class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
							mode="side"
							opened
							position="end"
						>
							<header class="tw-p-4 p-12px">
								<div class="rtl:text-left ltr:text-right">
									<button (click)="sidenav.toggle()">
										<img alt="" src="./assets/images/close-square.svg" />
									</button>
								</div>
							</header>
							<app-client-profile-payout-filter
								#payoutFilter
								(emitFilter)="getPayoutList($event); sidenav.toggle()"
								(emitfilterCount)="payoutfilterCount = $event"
								[filterData]="clientPayoutFilter"
							></app-client-profile-payout-filter>
						</mat-sidenav>
					</mat-sidenav-container>
				</ng-container>
				<div *ngIf="clientBookingFilter.activeTab == 1">
					<app-no-data-found
						*ngIf="!payoutDataTable?.length && !isFliped"
					></app-no-data-found>
				</div>
			</section>
			<div
				*ngIf="!isFliped && clientBookingFilter.activeTab == 1"
				class="mt-2 max-mobile:overflow-auto"
			>
				<app-pagination
					(currentPage)="
						pageChanged($event, clientBookingFilter.paging.pageSize)
					"
					(itemsCountPerPage)="pageChanged(1, $event)"
					[pageCount]="clientBookingFilter.paging.pageSize"
					[pageNumber]="clientBookingFilter.paging.pageNumber"
					[totalCount]="payoutCount"
				></app-pagination>
			</div>

			<section *ngIf="clientBookingFilter.activeTab == 2">
				<app-client-profile-table
					[clientProfileTableDetails]="clientBookingFilter"
					[selectedCountry]="clientBookingFilter.countryId"
					[tableDetails]="tableData"
					[totalCount]="totalCount"
				></app-client-profile-table>

				<div class="mt-8 py-5 max-mobile:overflow-auto">
					<app-pagination
						(currentPage)="
							pageChanged($event, clientBookingFilter.paging.pageSize)
						"
						(itemsCountPerPage)="pageChanged(1, $event)"
						[pageCount]="clientBookingFilter.paging.pageSize"
						[pageNumber]="clientBookingFilter.paging.pageNumber"
						[totalCount]="totalCount"
					></app-pagination>
				</div>
			</section>
		</div>
	</div>
</div>
